export default __webpack_public_path__ + "static/media/emailTemplate.c33450d1.png";